import { 
  LayoutDashboard,
  CircleDollarSign,
  Shield,
  LineChart,
  Briefcase,
  Database
} from 'lucide-react';

// Définition des secteurs
export const sectors = [
  {
    id: 'core-banking',
    name: 'Core Banking',
    description: 'Solutions bancaires fondamentales',
    icon: LayoutDashboard
  },
  {
    id: 'payments',
    name: 'Paiements & Transactions',
    description: 'Solutions de paiement et processing',
    icon: CircleDollarSign
  },
  {
    id: 'risk-compliance',
    name: 'Risque & Conformité',
    description: 'Gestion des risques et conformité réglementaire',
    icon: Shield
  },
  {
    id: 'markets',
    name: 'Marchés & Trading',
    description: 'Solutions pour les activités de marché',
    icon: LineChart
  },
  {
    id: 'wealth',
    name: 'Wealth & Asset Management',
    description: 'Gestion de patrimoine et d\'actifs',
    icon: Briefcase
  },
  {
    id: 'data',
    name: 'Data & Analytics',
    description: 'Solutions de données et analyse',
    icon: Database
  }
];

// Définition des catégories
export const categories = [
  {
    id: 'platform',
    name: 'Plateformes',
    description: 'Solutions complètes et modulaires'
  },
  {
    id: 'solution',
    name: 'Solutions',
    description: 'Applications dédiées'
  },
  {
    id: 'service',
    name: 'Services',
    description: 'Services professionnels et support'
  }
];

// Map des icônes par secteur
const sectorIcons = {
  'core-banking': LayoutDashboard,
  'payments': CircleDollarSign,
  'risk-compliance': Shield,
  'markets': LineChart,
  'wealth': Briefcase,
  'data': Database
};

// Import dynamique des produits
function importAllProducts() {
  const context = require.context('./products', false, /\.json$/);
  const products = {};
  
  context.keys().forEach((key) => {
    const productId = key.replace(/^\.\/(.*)\.json$/, '$1');
    const productData = context(key);
    
    // Détection automatique du secteur basée sur les modules ou l'overview
    let detectedSector = 'data'; // Valeur par défaut
    
    // Analyse des modules pour détecter le secteur
    if (productData.modules) {
      const moduleTypes = productData.modules.map(m => m.id).join(' ');
      
      if (moduleTypes.includes('account') || moduleTypes.includes('banking')) {
        detectedSector = 'core-banking';
      } else if (moduleTypes.includes('payment') || moduleTypes.includes('transaction')) {
        detectedSector = 'payments';
      } else if (moduleTypes.includes('risk') || moduleTypes.includes('compliance')) {
        detectedSector = 'risk-compliance';
      } else if (moduleTypes.includes('trading') || moduleTypes.includes('market')) {
        detectedSector = 'markets';
      } else if (moduleTypes.includes('wealth') || moduleTypes.includes('asset')) {
        detectedSector = 'wealth';
      }
    }
    
    // Détection de la catégorie basée sur la structure du produit
    let detectedCategory = 'solution'; // Valeur par défaut
    if (productData.modules && productData.modules.length > 2) {
      detectedCategory = 'platform';
    } else if (productData.type === 'service' || productData.deployment?.services) {
      detectedCategory = 'service';
    }
    
    products[productId] = {
      ...productData,
      sector: detectedSector,
      category: detectedCategory,
      icon: sectorIcons[detectedSector]
    };
  });
  
  return products;
}

// Export des produits avec leurs données complètes
export const products = importAllProducts();

// Fonctions utilitaires (inchangées)
export const getProductsByFilters = (sectorFilter = 'all', categoryFilter = 'all') => {
  return Object.values(products).filter(product => 
    (sectorFilter === 'all' || product.sector === sectorFilter) &&
    (categoryFilter === 'all' || product.category === categoryFilter)
  );
};

export const getRelatedProducts = (productId, limit = 3) => {
  const currentProduct = products[productId];
  if (!currentProduct) return [];
  
  return Object.values(products)
    .filter(product => 
      product.id !== productId && 
      (product.sector === currentProduct.sector || 
       product.category === currentProduct.category)
    )
    .slice(0, limit);
};